module.exports = __webpack_public_path__ + "static/media/loading.88714a27.gif";